module.exports = "//static.hsappstatic.net/conversations-visitor-experience-components/static-1.17999/img/visitor-widget/bot-avatar.svg"